import React from "react"

import {FieldControlViewProps} from "../../../../render/control-view"

type State = {
    currentValue       : any
    showPopover         : boolean
}

// const debug = "FieldSelectField_ControlView"
const debug = false

export default class FieldSelectField_ControlView extends React.Component<FieldControlViewProps, State> {

    public previousValue        : any

    constructor(props: FieldControlViewProps) {
        super(props);

        const value = this.props.model[this.props.field.fieldId]

        this.state = {
            currentValue    : value,
            showPopover     : false,
        }

        debug && console.log(debug, 'constructor', this.state)
    }

    // required to update current value if props value changed
    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
        const previousValue = prevProps.model[prevProps.field.fieldId]
        const currentValue  = this.props.model[this.props.field.fieldId]

        if (previousValue !== currentValue) {
            this.setState({
                currentValue: currentValue,
            })
        }
    }

    showPopover = () => {
        if (!this.state.showPopover && !this.props.disabled) {
            this.setState({
                showPopover: true
            })
        }
    }

    hidePopover = () => {
        debug && console.log(debug, 'hidePopover', this.state.showPopover)

        if (this.state.showPopover) {
            this.setState({
                showPopover: false
            })
        }
    }

    onValueChange = (newValue: any, hidePopover: boolean = true) => {
        debug && console.log(debug, 'onValueChange', newValue, hidePopover)

        this.previousValue = this.state.currentValue

        this.setState({
            currentValue: newValue
        }, () => {
            this.props.onChange?.(newValue, this.onCancelChange)
            if (hidePopover) {
                this.hidePopover()
            }
        })
    }

    onReset = () => {
        this.onValueChange(null, true)
    }

    onOptionClick = (option:any) => {
        const newValue = _.get(option, 'value', null)
        this.onValueChange(newValue)
    }

    onCancelChange = () => {
        this.setState({
            currentValue: this.previousValue
        })
    }

    render() {
        const classes = Classes(this.props.className, {
            'show-popover' : this.state.showPopover,
        })

        debug && console.log(debug, 'render', this.state.showPopover)

        const isNotEmpty = !_.isNil(this.state.currentValue) && (!Array.isArray(this.state.currentValue) || !_.isEmpty(this.state.currentValue))

        if (isNotEmpty) {
            return (
                <this.props.field.components.ControlViewNotEmpty
                    className   = {classes}
                    field       = {this.props.field}
                    value       = {this.state.currentValue}
                    onClick     = {this.showPopover}
                    onChange    = {this.onOptionClick}
                >
                    {this.state.showPopover &&
                        <this.props.field.components.PopoverMenu
                            {...this.props}
                            parent={this}
                        />}
                </this.props.field.components.ControlViewNotEmpty>
            )
        } else {
            return (
                <this.props.field.components.ControlViewEmpty
                    className   = {classes}
                    field       = {this.props.field}
                    onClick     = {this.showPopover}
                >
                    {this.state.showPopover &&
                        <this.props.field.components.PopoverMenu
                            {...this.props}
                            parent={this}
                        />}
                </this.props.field.components.ControlViewEmpty>
            )
        }
    }
}
